module.exports = __webpack_public_path__ + "04fe242e1e4989b27935525eab9669b7.MP3";